import PropTypes from 'prop-types';
export const dateDetailsPropTypes = {
  /**
   * The array of objects which contains data like: label, datetime and date
   */
  dates: PropTypes.arrayOf(PropTypes.exact({
    label: PropTypes.string.isRequired,
    datetime: PropTypes.string.isRequired,
    date: PropTypes.string.isRequired
  })).isRequired,
  /**
   * The text to display in tooltip footer
   */
  footerText: PropTypes.string
};